import React, { useState, useEffect } from "react";
import Pagination from "../../components/ui/Pagination";
import { getInwardReceipts } from "../../api/inventory";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import Subnav from "../../components/inventory/SubNav";

const InwardReceiptsDashboard = () => {
  const [receipts, setReceipts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchReceipts = async (page = 1) => {
    try {
      setReceipts([]);
      const response = await getInwardReceipts({
        params: { page, pageSize: 10 },
      });
      setReceipts(response?.receipts);
      setTotalPages(Math.ceil(response?.pagination?.totalRecords / 10 || 0));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching inward receipts:", error);
    }
  };

  useEffect(() => {
    fetchReceipts(currentPage);
  }, [currentPage]);

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <Navbar />
      <Subnav />
      <div className="container mx-auto p-6">
        <h2 className="text-3xl font-semibold text-gray-800 mb-6">
          Recent Inward Receipts
        </h2>

        <div className="overflow-x-auto rounded-lg">
          <table className="min-w-full bg-white rounded-lg shadow-xl border border-gray-300">
            <thead className="bg-gradient-to-r from-rose-800 to-gray-400 shadow-xl text-white">
              <tr>
                <th className="p-3 text-left text-sm font-medium">
                  Invoice Number
                </th>
                <th className="p-3 text-left text-sm font-medium">
                  Invoice Date
                </th>
                <th className="p-3 text-left text-sm font-medium">Product</th>
                <th className="p-3 text-left text-sm font-medium">Cases</th>
                <th className="p-3 text-left text-sm font-medium">
                  Cost per Case
                </th>
                <th className="p-3 text-left text-sm font-medium">Tax Rate</th>
              </tr>
            </thead>
            <tbody className="text-gray-700">
              {receipts.map((receipt) => (
                <React.Fragment key={receipt.inward_receipt_id}>
                  {receipt.items.map((item, index) => (
                    <tr
                      key={item.product_id}
                      className={`hover:bg-gray-300 transition-colors border-b-1 border-gray-300 ${
                        index === 0 ? "bg-gray-100" : ""
                      }`}
                    >
                      {index === 0 && (
                        <>
                          {/* Only render invoice info in the first row for the receipt */}
                          <td
                            className="p-4 text-sm font-medium"
                            rowSpan={receipt.items.length}
                          >
                            {receipt.invoice_number}
                          </td>
                          <td
                            className="p-4 text-sm font-medium"
                            rowSpan={receipt.items.length}
                          >
                            {new Date(
                              receipt.invoice_date
                            ).toLocaleDateString()}
                          </td>
                        </>
                      )}
                      <td className="p-4 text-sm">{item.name} - {item.size_label}</td>
                      <td className="p-4 text-sm">{item.cases}</td>
                      <td className="p-4 text-sm">
                       ₹{Number(item.cost_per_case).toFixed(2)}
                      </td>
                      <td className="p-4 text-sm">
                        {item.tax_rate}%
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination component */}
        <Pagination
          totalPages={totalPages}
          currentPage={currentPage}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
      <Footer />
    </div>
  );
};

export default InwardReceiptsDashboard;
